/**
 * Announcement bar scroll reveal.
 *
 * Behaviour:
 *  - At the top of the page the announcement bar sits where it always did.
 *  - Scrolling down slides it up out of view.
 *  - Scrolling up slides it back in at the very top and pushes the sticky header down.
 *
 * Everything is applied as inline styles so it cannot be defeated by stylesheet
 * ordering or by a missing section class. A spacer element keeps the page layout
 * identical to before, since the bar itself becomes position: fixed.
 */
(function () {
  if (window.__announcementScrollReveal) return;
  window.__announcementScrollReveal = true;

  var THRESHOLD = 5;
  var DURATION = '0.35s';
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var TRANSITION = 'transform ' + DURATION + ' ' + EASING;

  var section = null;
  var spacer = null;
  var headerSection = null;
  var resizeObserver = null;
  var height = 0;
  var hidden = null;
  var lastY = 0;
  var ticking = false;

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function findSection() {
    var el = document.querySelector('.announcement-bar-section');
    if (el) return el;

    var bar = document.querySelector('.announcement-bar');
    return bar && bar.closest ? bar.closest('.shopify-section') : null;
  }

  function getBar() {
    if (!section) return null;
    return section.querySelector('.announcement-bar') || section;
  }

  function applyHeaderOffset(instant) {
    if (!headerSection) return;

    if (instant) headerSection.style.transition = 'none';
    headerSection.style.top = (hidden ? -1 : height - 1) + 'px';

    if (instant) {
      void headerSection.offsetHeight;
      headerSection.style.transition = reduceMotion() ? 'none' : 'top ' + DURATION + ' ' + EASING;
    }
  }

  function measure() {
    var bar = getBar();
    if (!bar) return;

    var next = Math.round(bar.getBoundingClientRect().height);
    if (!next || next === height) return;

    height = next;
    if (spacer) spacer.style.height = height + 'px';
    document.body.style.setProperty('--announcement-bar-height', height + 'px');
    applyHeaderOffset(true);
  }

  function setHidden(next, instant) {
    if (!section || hidden === next) return;

    hidden = next;

    if (instant) section.style.transition = 'none';
    section.style.transform = hidden ? 'translateY(-101%)' : 'translateY(0)';
    applyHeaderOffset(instant);

    if (instant) {
      void section.offsetHeight;
      section.style.transition = reduceMotion() ? 'none' : TRANSITION;
    }
  }

  function setup() {
    section = findSection();
    if (!section) return false;

    var bar = getBar();
    height = Math.round(bar.getBoundingClientRect().height) || 0;

    // Reserve the space the bar used to occupy, outside of #header-group so the
    // theme's own header height maths keeps working.
    var headerGroup = document.getElementById('header-group') || section.parentNode;

    if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
    spacer = document.createElement('div');
    spacer.setAttribute('aria-hidden', 'true');
    spacer.className = 'announcement-bar-spacer';
    spacer.style.height = height + 'px';
    spacer.style.flexShrink = '0';
    if (headerGroup.parentNode) {
      headerGroup.parentNode.insertBefore(spacer, headerGroup);
    }

    section.style.position = 'fixed';
    section.style.top = '0';
    section.style.left = '0';
    section.style.right = '0';
    section.style.zIndex = '9';
    section.style.willChange = 'transform';
    section.style.transition = reduceMotion() ? 'none' : TRANSITION;

    headerSection = document.querySelector('.header-section');
    if (headerSection) {
      headerSection.style.transition = reduceMotion() ? 'none' : 'top ' + DURATION + ' ' + EASING;
    }

    document.body.style.setProperty('--announcement-bar-height', height + 'px');

    if (window.ResizeObserver) {
      if (resizeObserver) resizeObserver.disconnect();
      resizeObserver = new ResizeObserver(measure);
      resizeObserver.observe(bar);
    }

    hidden = null;
    setHidden((window.scrollY || 0) > height, true);

    return true;
  }

  function update() {
    ticking = false;

    if (!section || !section.isConnected) {
      if (!setup()) return;
    }

    var y = window.scrollY || 0;
    if (y < 0) y = 0;

    var delta = y - lastY;

    if (y <= height) {
      setHidden(false, false);
    } else if (delta > THRESHOLD) {
      setHidden(true, false);
    } else if (delta < -THRESHOLD) {
      setHidden(false, false);
    }

    lastY = y;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function init() {
    lastY = window.scrollY || 0;
    if (!setup()) return;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure, { passive: true });
    window.addEventListener('load', measure);

    document.addEventListener('shopify:section:load', function () {
      section = null;
      setup();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
